
import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as rtoInfoReducerInitialState, HANDLERS as rtoInfoReducerHandler } from "../../../components/desktop/rto-info/reducers";
import { INITIAL_STATE as registrationNoReducerInitialState, HANDLERS as registrationNoReducerHandler } from "../../../components/desktop/car-registration-number/reducer";
import { INITIAL_STATE as myChallansReducerInitialState, HANDLERS as myChallansReducerHandler } from "../../../components/desktop/my-challans/reducer";

export default {
    [reducerConstants.RTO_INFO]: { state: rtoInfoReducerInitialState, handler: rtoInfoReducerHandler },
    [reducerConstants.REG_NO]: { state: registrationNoReducerInitialState, handler: registrationNoReducerHandler },
    [reducerConstants.MY_CHALLANS]: { state: myChallansReducerInitialState, handler: myChallansReducerHandler}
};

